import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useCart } from '../../contexts/CartContext';

export default function CarritoPage() {
  const { cart, removeFromCart, updateQuantity, getCartTotal } = useCart();

  if (cart.length === 0) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-24 md:pt-32 pb-16 md:pb-24 px-4 md:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-20 h-20 md:w-24 md:h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shopping-bag-line text-4xl md:text-5xl text-gray-400"></i>
            </div>
            <h1 className="text-3xl md:text-4xl font-light mb-4">Tu carrito está vacío</h1>
            <p className="text-gray-600 mb-8 text-sm md:text-base">Agrega productos para comenzar tu compra</p>
            <Link
              to="/catalogo"
              className="inline-block px-6 md:px-8 py-3 bg-[#F2C4CE] text-gray-900 rounded-full hover:bg-[#e8adb8] transition-colors whitespace-nowrap text-sm md:text-base"
            >
              Explorar Catálogo
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-24 md:pt-32 pb-16 md:pb-24 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-light mb-8 md:mb-12">Carrito de Compras</h1>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
            <div className="lg:col-span-2">
              <div className="space-y-4 md:space-y-6">
                {cart.map((item) => (
                  <div
                    key={item.id}
                    className="flex flex-col md:flex-row gap-4 md:gap-6 bg-gray-50 rounded-2xl md:rounded-3xl p-4 md:p-6 hover:shadow-md transition-shadow"
                  >
                    <div className="w-20 h-20 md:w-32 md:h-32 flex-shrink-0 mx-auto md:mx-0">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-full h-full object-cover rounded-xl md:rounded-2xl"
                      />
                    </div>

                    <div className="flex-1 text-center md:text-left">
                      <h3 className="text-lg md:text-xl font-medium text-gray-900 mb-2">{item.name}</h3>
                      <p className="text-xl md:text-2xl font-light text-gray-900 mb-4">${item.price}</p>

                      <div className="flex flex-col md:flex-row items-center justify-center md:justify-start gap-4">
                        <div className="flex items-center gap-3 bg-white rounded-full px-4 py-2">
                          <button
                            onClick={() => updateQuantity(item.id, item.quantity - 1)}
                            className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors"
                            aria-label="Disminuir cantidad"
                          >
                            <i className="ri-subtract-line"></i>
                          </button>
                          <span className="w-8 text-center font-medium">{item.quantity}</span>
                          <button
                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                            className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors"
                            aria-label="Aumentar cantidad"
                          >
                            <i className="ri-add-line"></i>
                          </button>
                        </div>

                        <button
                          onClick={() => removeFromCart(item.id)}
                          className="text-red-500 hover:text-red-700 transition-colors whitespace-nowrap"
                        >
                          <i className="ri-delete-bin-line text-xl"></i>
                        </button>
                      </div>
                    </div>

                    <div className="text-center md:text-right mt-2 md:mt-0">
                      <p className="text-xl md:text-2xl font-medium text-gray-900">
                        ${(item.price * item.quantity).toFixed(2)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <Link
                to="/catalogo"
                className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors mt-6 md:mt-8 whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-arrow-left-line"></i>
                <span>Continuar Comprando</span>
              </Link>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-gray-50 rounded-2xl md:rounded-3xl p-6 md:p-8 lg:sticky lg:top-32">
                <h2 className="text-xl md:text-2xl font-medium mb-6">Resumen del Pedido</h2>

                <div className="space-y-4 mb-6">
                  <div className="flex justify-between text-gray-600 text-sm md:text-base">
                    <span>Subtotal</span>
                    <span>${getCartTotal().toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between text-gray-600 text-sm md:text-base">
                    <span>Envío</span>
                    <span>Gratis</span>
                  </div>
                  <div className="border-t border-gray-200 pt-4">
                    <div className="flex justify-between text-lg md:text-xl font-medium">
                      <span>Total</span>
                      <span>${getCartTotal().toFixed(2)}</span>
                    </div>
                  </div>
                </div>

                <Link
                  to="/checkout"
                  className="block w-full py-3 md:py-4 bg-[#F2C4CE] text-gray-900 text-center rounded-full hover:bg-[#e8adb8] transition-colors mb-4 whitespace-nowrap text-sm md:text-base"
                >
                  Proceder al Pago
                </Link>

                <div className="space-y-3 text-xs md:text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-shield-check-line text-base md:text-lg"></i>
                    <span>Compra 100% segura</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-truck-line text-base md:text-lg"></i>
                    <span>Envío gratis en pedidos &gt; $100</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-arrow-go-back-line text-base md:text-lg"></i>
                    <span>Devoluciones en 30 días</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}